export default {
    supportedLngs: ["en", "de"],
    fallbackLng: "en",
    defaultNS: "common",
    error: {
        unauthorized: {
            title: "Unauthorized Access",
            message: "You don't have permission to access this page"
        }
    },
};
